import React from "react";
import InfoCard from "src/components/InfoCard";
import Layout from "src/components/Layout";

const SeafarerMedical: React.FC = () => {
  return (
    <Layout>
      <InfoCard
        title={`Seafarer Medical Fitness Assessment (In Accordance with STCW, MLC 2006, ILO Guidelines)`}
        zeroPadding
      >
        <ul
          style={{
            color: "#000866",
            marginTop: "10px",
            marginBottom: "10px",
          }}
        >
          <li>Personnel Service on Board Medical Fitness Certificate</li>
          <li>Vanutu Medical Fitness Certificate</li>
          <li>Liberia Medical Fitness Certificate</li>
          <li>Marshall Islands Medical Fitness Certificate</li>
          <li>Panama Medical Fitness Certificate.</li>
        </ul>
      </InfoCard>
    </Layout>
  );
};

export default SeafarerMedical;
